import React, {useState} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid, Paper,
    Stack, Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@mui/material";
import {UserDto} from "../../../modules/account/dto/UserDto";
import CloseButton from "../../../components/buttons/CloseButton";
import FormFieldText from "../../../components/FormFieldText";
import SearchButton from "../../../components/buttons/SearchButton";
import {UserSearchCondition} from "../../../modules/account/dto/UserSearchCondition";
import {UserApi} from "../../../modules/account/api/UserApi";
import {HttpStatus} from "../../../modules/common/enums/HttpStatus";
import {PaginationDto} from "../../../modules/common/dto/PaginationDto";
import PaginationBar from "../../../components/PaginationBar";

export type UserSelectDialogProps = {
    open: boolean;
    onSelect: (value: UserDto) => void;
    onClose: () => void;
};

const UserSelectDialog: React.FC<UserSelectDialogProps> = (props) => {
    const intl = useIntl();
    // 查询条件
    const [searchCondition, setSearchCondition] = useState(new UserSearchCondition());

    // 查询结果
    const [searchResult, setSearchResult] = useState(new Array<UserDto>());

    // 分页数据
    const [pagination, setPagination] = useState(new PaginationDto());

    const handleCancel = () => {
        props.onClose();
    };

    const handleSelect = (item: UserDto) => {
        props.onSelect(item);
        props.onClose();
    }

    const handleChangeCondition = (name: string, value: any) => {
        setSearchCondition({...searchCondition, [name]: value});
    };

    const handleSearch = async (searchCondition: UserSearchCondition) => {
        const responseResult = await UserApi.queryUsers(searchCondition);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setSearchResult(responseResult.data);
            setPagination(responseResult.pagination);
        }
    };

    const handlePagination = (page: number, pageSize: number) => {
        const newSearchCondition = Object.assign({}, searchCondition);
        newSearchCondition.currentPage = page;
        newSearchCondition.pageSize = pageSize;
        handleSearch(newSearchCondition);
    };

    return (
        <Dialog open={props.open} onClose={handleCancel} fullWidth={true} maxWidth={'lg'}>
            <DialogTitle>
                <Stack direction={'row'} justifyContent={'space-between'}>
                    <FormattedMessage id={'ACCOUNT_USER_SEARCH'}/>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Paper sx={{p: 1}}>
                    <Grid container columnSpacing={2} alignItems="center">
                        <Grid item>
                            <FormFieldText label={intl.formatMessage({id: "ACCOUNT_USER_UID"})}
                                           value={searchCondition.uid}
                                           onChange={(value) => {
                                               handleChangeCondition("uid", value)
                                           }}/>
                        </Grid>
                        <Grid item>
                            <FormFieldText label={intl.formatMessage({id: "ACCOUNT_USER_NAME"})}
                                           value={searchCondition.name}
                                           onChange={(value) => {
                                               handleChangeCondition("name", value)
                                           }}/>
                        </Grid>
                        <Grid item>
                            <FormFieldText label={intl.formatMessage({id: "ACCOUNT_USER_MOBILE"})}
                                           value={searchCondition.mobile}
                                           onChange={(value) => {
                                               handleChangeCondition("mobile", value)
                                           }}/>
                        </Grid>
                        <Grid item>
                            <FormFieldText label={intl.formatMessage({id: "ACCOUNT_USER_EMAIL"})}
                                           value={searchCondition.email}
                                           onChange={(value) => {
                                               handleChangeCondition("email", value)
                                           }}/>
                        </Grid>
                        <Grid item>
                            <Stack direction={'row'} spacing={2}>
                                <SearchButton onClick={() => handleSearch(searchCondition)}/>
                            </Stack>
                        </Grid>
                    </Grid>
                </Paper>
                <Paper sx={{p: 1}}>
                    <PaginationBar pagination={pagination} onChange={handlePagination}/>
                    <br/>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell><FormattedMessage id={'ACCOUNT_USER_UID'}/></TableCell>
                                <TableCell><FormattedMessage id={'ACCOUNT_USER_NAME'}/></TableCell>
                                <TableCell><FormattedMessage id={'ACCOUNT_USER_MOBILE'}/></TableCell>
                                <TableCell><FormattedMessage id={'ACCOUNT_USER_EMAIL'}/></TableCell>
                                <TableCell><FormattedMessage id={'COMMON_ACTION'}/></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {searchResult.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{item.uid}</TableCell>
                                    <TableCell>{item.fullName}</TableCell>
                                    <TableCell>{item.mobile}</TableCell>
                                    <TableCell>{item.email}</TableCell>
                                    <TableCell>
                                        <Button size="small" onClick={() => handleSelect(item)}>
                                            <FormattedMessage id={'COMMON_SELECT'}/></Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
            </DialogContent>
            <DialogActions>
                <CloseButton onClick={handleCancel}/>
            </DialogActions>
        </Dialog>
    );
};

export default UserSelectDialog;
